module.exports = __webpack_public_path__ + "static/media/gold_ticket_large.23dab85e.png";